import { styled, css } from '@vebox/etui-system';
import { createElement } from 'react';
import '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Label } from '@vebox/etui-system-elements';
import CheckboxBase from './CheckboxBase.js';
import './utils.js';

const CheckboxCircle = styled(Label)`
  display: block;
  padding: 8px 8px 8px 7px;
  font-size: ${({
  theme
}) => theme.typography.fontSizeLarge};
  line-height: 10px;
  border: 1px solid ${({
  theme
}) => theme.palette.primary.main};
  color: ${({
  theme
}) => theme.palette.primary.main};
  border-radius: 50%;
  white-space: nowrap;
  cursor: pointer;
  text-transform: uppercase;

  ${({
  theme,
  checked,
  disabled
}) => {
  if (checked && !disabled) {
    return css`
        border-color: ${theme.palette.primary.main};
        background-color: ${theme.palette.primary.main};
        color: ${theme.palette.common.white};
      `;
  }
  if (disabled) {
    return css`
        border-color: ${theme.palette.action.disabledBackground};
        background-color: ${theme.palette.action.disabledBackground};
      `;
  }
  return ``;
}};
`;

/**
 * @deprecated
 * */
const CheckboxCircle$1 = props => {
  const {
    checked,
    disabled,
    indeterminate,
    labelText
  } = props;
  return /*#__PURE__*/createElement(CheckboxBase, props, /*#__PURE__*/createElement(CheckboxCircle, {
    checked: checked,
    disabled: disabled,
    indeterminate: indeterminate
  }, labelText));
};

export default CheckboxCircle$1;
